import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import Loader from './Loader';

function AutoCompleteLoader({ loading }) {
  return (
    <CSSTransition
      classNames="ui-autocomplete-loader-container"
      timeout={150}
      in={loading}
      mountOnEnter
      unmountOnExit
    >
      <div className="ui-autocomplete-loader-container">
        <Loader className="ui-autocomplete-loader" />
      </div>
    </CSSTransition>
  );
}

AutoCompleteLoader.propTypes = {
  loading: PropTypes.bool,
};

export default memo(AutoCompleteLoader);
